'use client';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useMediaQuery } from "./chunk-57I6FYPZ.mjs"; // src/media-query.hook.ts

function usePrefersReducedMotion(options) {
  var _useMediaQuery = useMediaQuery("(prefers-reduced-motion: reduce)", options),
      _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
      prefersReducedMotion = _useMediaQuery2[0];

  return prefersReducedMotion;
}

function useColorModePreference(options) {
  var _useMediaQuery3 = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options),
      _useMediaQuery4 = _slicedToArray(_useMediaQuery3, 2),
      isLight = _useMediaQuery4[0],
      isDark = _useMediaQuery4[1];

  if (isLight) return "light";
  if (isDark) return "dark";
  return void 0;
}

export { usePrefersReducedMotion, useColorModePreference };